"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrBeUsd = exports.FrBeEur = exports.NlBeUsd = exports.NlBeEur = exports.EnBeUsd = exports.EnBeEur = void 0;
class EnBeEur {
    constructor() {
        this.locale = "en-be";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnBeEur = EnBeEur;
class EnBeUsd {
    constructor() {
        this.locale = "en-be";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnBeUsd = EnBeUsd;
class NlBeEur {
    constructor() {
        this.locale = "nl-be";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.NlBeEur = NlBeEur;
class NlBeUsd {
    constructor() {
        this.locale = "nl-be";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.NlBeUsd = NlBeUsd;
class FrBeEur {
    constructor() {
        this.locale = "fr-be";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.FrBeEur = FrBeEur;
class FrBeUsd {
    constructor() {
        this.locale = "fr-be";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.FrBeUsd = FrBeUsd;
